import { render, staticRenderFns } from "./make_order.vue?vue&type=template&id=7b8346e5"
import script from "./make_order.vue?vue&type=script&lang=js"
export * from "./make_order.vue?vue&type=script&lang=js"
import style0 from "./make_order.vue?vue&type=style&index=0&id=7b8346e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports